import { render } from "./CCWNAbnormalCallList.vue?vue&type=template&id=43014736&scoped=true"
import script from "./CCWNAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./CCWNAbnormalCallList.vue?vue&type=script&lang=js"

import "./CCWNAbnormalCallList.vue?vue&type=style&index=0&id=43014736&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43014736"

export default script